import { Box } from '@mui/material';
import type { PropsWithChildren } from 'react';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import type { SaleEventProps } from './useSaleEvent';

interface SalesBorderWrapperProps extends PropsWithChildren<any> {
  selected: boolean;
  matchingSaleEvent?: SaleEventProps;
  hide?: boolean;
  withRadioSelection?: boolean;
}

interface StyleProps {
  selected?: boolean;
  additional?: any;
}

const useStyles = makeStyles<StyleProps>()((_theme, props) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: props.selected ? '2px solid #fff' : undefined,
    borderRadius: 3,
    padding: '8px 8px 8px 0',
    ...(props.selected ? props.additional?.radioContainer : undefined),
  },
  saleBorderText: {
    position: 'absolute',
    top: -11,
    right: 10,
    padding: '0 5px',
    background: '#303031',
    ...props.additional?.radioBorderText,
  },
}));

const SalesBorderWrapper: React.FC<SalesBorderWrapperProps> = ({
  selected,
  matchingSaleEvent,
  children,
  hide,
  withRadioSelection,
}) => {
  const { classes } = useStyles({ selected, additional: matchingSaleEvent?.styles });
  if (hide) {
    return <div>{children}</div>;
  }
  return (
    <Box className={classes.container}>
      {!withRadioSelection && matchingSaleEvent && <div />}
      {matchingSaleEvent && selected && (
        <div className={classes.saleBorderText}>{matchingSaleEvent.borderText}</div>
      )}
      {children}
    </Box>
  );
};

export default SalesBorderWrapper;
